import axios from "axios";
import Swal from "sweetalert2";
import { getActiveTenant, getSession, clearSession } from "../config/tenants";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

// Cliente (backend) ativo, resolvido na carga da página (ver src/config/tenants.js).
// Sem cliente ativo (vários cadastrados e nenhum escolhido), baseURL fica indefinida
// e só a tela de login, com o seletor, é utilizável.
const tenant = getActiveTenant();
export const baseURL = tenant ? tenant.url : undefined;
console.log("URL da API:", baseURL, tenant ? `(cliente: ${tenant.slug})` : "(nenhum cliente selecionado)");

// Token do cliente ativo.
export const getToken = () => (tenant ? getSession(tenant.slug).token : null);

// O token só vai para o backend do cliente ativo: nunca para outra URL.
const isTenantUrl = (url) => !!baseURL && typeof url === "string" && url.startsWith(`${baseURL}/`);

axios.interceptors.request.use((config) => {
  if (!isTenantUrl(config.url)) {
    if (config.headers) delete config.headers.Authorization;
    return config;
  }
  const token = getToken();
  if (token && config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para capturar erros 403
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      Swal.fire({
        icon: "warning",
        title: "Sessão expirada",
        text: "Por favor, faça login novamente.",
      }).then(() => {
        if (tenant) clearSession(tenant.slug); // encerra só a sessão do cliente ativo
        window.location.href = "/login"; // redireciona para a página de login
      });
    }

    // Retorna a rejeição para permitir o tratamento normal de erros em outros lugares
    return Promise.reject(error);
  }
);

// Fazer login por token
export const createSession = (login, password) => {
  if (!baseURL) {
    Swal.fire({
      icon: "warning",
      title: "Selecione o cliente",
      text: "Escolha o cliente antes de entrar.",
    });
    return Promise.resolve(undefined);
  }
  return axios
    .post(
      // método da requisição
      `${baseURL}/login`,
      {
        // URL base + rota de login
        login, // parâmetros
        password,
      }
    )
    .then((response) => {
      // Promise (resposta da requisição); a sessão é gravada pelo AuthProvider
      return response;
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Usuário ou senha incorretos!",
      });
    });
};
